import {createAction} from '@reduxjs/toolkit'

import type {PaymentMethodConfiguration} from 'services/payment/paymentMethods'

export const setPspInitialized = createAction<boolean>(
  'common/setPspInitialized'
)
export const setPayrailsInitialized = createAction<boolean>(
  'common/setPayrailsInitialized'
)
export const setEnabledWallets = createAction<PaymentMethodConfiguration[]>(
  'common/setEnabledWallets'
)

export type ActionType =
  | ReturnType<typeof setPspInitialized>
  | ReturnType<typeof setPayrailsInitialized>
  | ReturnType<typeof setEnabledWallets>
